import React from 'react'
import { PartialShoesAction, ShoesState } from 'src/types'
import { shoesBaseModels } from 'src/features/atoms/glove/japan/constants/baseModel'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/atoms/glove/japan/constants/actionType'
import { ShoesBaseModelSelector } from 'src/Components/Domain/ShoesModelSelector'
import { initialShoesState, shoesReducer } from 'src/features/atoms/shoes/reducer'
import { ShoesSetters } from 'src/features/atoms/shoes/Components/Setter'
import { ShoesOrderPageTemplate } from 'src/Components/Domain/ShoesOrderPageTemplate'
import { useDrawShoesSide } from 'src/features/atoms/shoes/drawer/hooks/useDrawShoesSide'
import { useDrawShoesRear } from 'src/features/atoms/shoes/drawer/hooks/useDrawShoesRear'
import { useDrawShoesFront } from 'src/features/atoms/shoes/drawer/hooks/useDrawShoesFront'

const AtomsShoesSimulation: React.FC = () => {
  const models = shoesBaseModels()
  const [state, dispatch] = React.useReducer(shoesReducer, initialShoesState) as [ShoesState, React.Dispatch<PartialShoesAction>]
  const { figurePanelNum } = state
  const handleDrawerIndex = (_, newValue: 0 | 1 | 2 | 3) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })
  const frontSurfaceId = 'frontSurface'
  const rearSurfaceId = 'rearSurface'
  const sideSurfaceId = 'sideSurface'
  const soleSurfaceId = 'soleSurface'

  useDrawShoesFront(frontSurfaceId, state)
  useDrawShoesSide(sideSurfaceId, state)
  useDrawShoesRear(rearSurfaceId, state)

  return (
    <ShoesOrderPageTemplate
      breadcrumbTrail={`ATOMS / スパイク・シューズ`}
      {...{ drawerIndex: figurePanelNum, state, frontSurfaceId, rearSurfaceId, sideSurfaceId, soleSurfaceId, handleDrawerIndex }}
    >
      <ShoesBaseModelSelector {...{ state, models, dispatch }} />
      <ShoesSetters {...{ state, dispatch }} />
    </ShoesOrderPageTemplate>
  )
}

export default AtomsShoesSimulation
